import { render } from "./AuthChallenge.vue?vue&type=template&id=0f3a323d&scoped=true&ts=true"
import script from "./AuthChallenge.vue?vue&type=script&lang=ts"
export * from "./AuthChallenge.vue?vue&type=script&lang=ts"

import "./AuthChallenge.vue?vue&type=style&index=0&id=0f3a323d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f3a323d"]])

export default __exports__